import React, {Component, Fragment} from 'react';
import ReactGA from 'react-ga';
import {Helmet} from "react-helmet";
import NavTop from '../../containers/NavTop/NavTop';
import {Divider} from 'antd';
import './ContactPage.css';
// import ContactSection from '../../containers/ContactSection/ContactSection';
import WrappedContactForm from '../../common/ContactForm/ContactForm';
import QuoteBlock from '../../common/QuoteBlock/QuoteBlock';

class ContactPage extends Component {

  constructor(props){
    super(props);
    ReactGA.pageview(window.location.pathname + window.location.search);
  }
  
  componentWillMount(){
    let {pageOn} = this.props;
    console.log(pageOn);
  }

  render() {
    return (
      <Fragment>
        <Helmet>
            <meta charSet="utf-8" />
            <title>RealTimeTouch.com - Contact page</title>
            <link rel="canonical" href="https://www.realtimetouch.com/contact/" />
        </Helmet>
        <NavTop pageOn={this.props.pageOn} />
        <div className="ContactPage--subnavbar-container mobileoff">
          <div className="ContactPage--subnavbar center mobileoff">
          </div>  
          <div className="ContactPage--subnavbar2 center mobileoff">
          </div>
          <h2 className="ContactPage--subnavbar-headline mobileoff font-special-heading">Real Time Touch: Contact Form</h2>
        </div>
        <div className="ContactPage--container">
          <div className="ContactPage--container-subheading">
            <div className="mobileon mobile-heading2">Real Time Touch: Contact Form</div>
            
            {/* <h4 className="ContactPage--subheadline">Find out more about Real Time Touch technology and intellectual property</h4> */}
            {/* <p className="ContactPage--body">We're available to discuss possible partnerships, and our designs and technologies.</p> */}
            <QuoteBlock quote="3" background="QuoteBlock--container-inner-none" />
          </div>
        {/* <div className=""><Divider /></div> */}
          <div className="ContactPage--form"> 
          {/* <WrappedContactForm /> */}
          </div>
        </div>
      </Fragment>
    )
  }
 }

export default ContactPage;


// WEBPACK FOOTER //
// ./src/pages/ContactPage/ContactPage.js